import Const from 'const';
import {ComboUnitInterface} from 'components/organisms/teams-combinations/combo-unit';
import {LineupTeamCombinationsMapInterface} from 'components/organisms/teams-combinations/lineup-team-combinations-map.interface';

const LineupTeamCombinationsMap = {
    lineups: {},
    combinations: {},
};

class LineupTeamCombinations {
    constructor(public readonly data: LineupTeamCombinationsMapInterface = LineupTeamCombinationsMap) {}
    public getLineupIdsByCheckedCombinations(comboUnits: ComboUnitInterface[]): string[] {
        const {combinations} = this.data;

        const lineupIds: string[] = [];
        comboUnits.map((comboUnit) => {
            Object.keys(combinations[comboUnit.getUnitId()] || {}).map((lineupId) => lineupIds.push(lineupId));
        });

        return arrayUnique(lineupIds);
    }
}

const lineupTeamCombinations = new LineupTeamCombinations();

export default function (state = lineupTeamCombinations, action) {
    switch (action.type) {
        case Const.SET_LINEUP_TEAM_COMBINATIONS_MAP:
            return new LineupTeamCombinations(action.data);

        case Const.UNSET_LINEUPS:
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new LineupTeamCombinations();

        default:
            return state;
    }
}
